import { useEffect, useState } from "react";
import useSendDataToGTM from "@features/analytics/hooks/useSendDataToGTM";
import { GiftAnArticleButonFactory } from "@features/giftAnArticle/utils/helpers";
import { GiftAnArticleVersion } from "@features/giftAnArticle/utils/types";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import { LambdaResponsePayload } from "@routes/Article/types/Alacrity";
import { cn } from "@util/helpers";

type ArticleSubshareProps = {
  isPremium: boolean;
  handleGenerateGiftURLModal: () => void;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  alacrityRes?: LambdaResponsePayload;
  displayNewGiftIcon?: boolean;
  subshareVersion?: GiftAnArticleVersion;
  buttonClassname?: string;
  className?: string;
};

const ArticleSubshare = ({
  isPremium = false,
  handleGenerateGiftURLModal,
  setIsModalOpen,
  alacrityRes,
  subshareVersion = GiftAnArticleVersion.default,
  buttonClassname,
  className,
}: ArticleSubshareProps): React.ReactElement => {
  const { isSubscriber } = useUserInfo();
  const [isSubshareVisible, setIsSubshareVisible] = useState(false);

  useEffect(() => {
    if (isSubscriber && isPremium) {
      setIsSubshareVisible(true);
    }
  }, [isSubscriber, isPremium]);

  const sendDataToGTM = useSendDataToGTM();

  const handleClick = () => {
    sendDataToGTM({
      event: "custom_event",
      eventCategory: "bt subshare",
      eventAction: "click",
      eventLabel: "gift icon clicks for subscribers",
    });

    if (alacrityRes) {
      setIsModalOpen(true);
    } else {
      handleGenerateGiftURLModal();
    }
  };

  useEffect(() => {
    if (!isPremium) return;
    if (!isSubscriber) return;

    sendDataToGTM({
      event: "custom_event",
      eventCategory: "bt subshare",
      eventAction: "views",
      eventLabel: "gift icon exposure for subscribers",
    });
  }, [isPremium, isSubscriber, sendDataToGTM]);

  const GiftAnArticleButton = GiftAnArticleButonFactory({
    giftAnArticleVersion: subshareVersion,
  });

  return (
    <>
      {isSubshareVisible ? (
        <div
          data-testid="article-subshare-component"
          className={cn("h-full", className)}
        >
          <GiftAnArticleButton
            handleClick={handleClick}
            className={buttonClassname}
          />
        </div>
      ) : null}
    </>
  );
};

export default ArticleSubshare;
